export enum InstellingETLStatus {
	GEPLAND = 'Gepland',
	BEZIG = 'Bezig',
	HERSTART = 'Herstart',
	GEFAALD = 'Gefaald',
	GESLAAGD = 'Geslaagd',
}
